import React from "react";
import { useFormContext } from "react-hook-form";
import { OrderFormData } from "../../hooks/useOrderForm";
import { Select } from "../ui/select";

interface FormSelectProps {
  name: keyof OrderFormData;
  placeholder?: string;
  options: { value: string; label: string }[];
  disabled?: boolean;
  onValueChange?: (value: string) => void;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  name,
  placeholder,
  options,
  disabled,
  onValueChange,
}) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch(name);
  const error = errors[name];

  const handleValueChange = (newValue: string) => {
    setValue(name, newValue, { shouldValidate: true });
    onValueChange?.(newValue);
  };

  return (
    <div>
      <Select
        value={value}
        onValueChange={handleValueChange}
        placeholder={placeholder}
        disabled={disabled}
        options={options}
      />
      {error && (
        <div className="text-red-400 text-sm mt-2">
          {error.message as string}
        </div>
      )}
    </div>
  );
};
